(function () {
  const BACKEND_URL = 'https://j88tx9zh4i.execute-api.us-east-1.amazonaws.com';

  // Orden 23 · T4. `storeAttribution()` ya NO vive acá.
  //
  // Se movió a `snippets/refurbi-attribution.liquid`, que va inline en el <head> de
  // TODAS las páginas. Este asset se carga en un solo sitio —
  // `sections/main-cart.liquid`, o sea solo en /cart—, así que la captura nunca
  // corría en la página de aterrizaje, que es la única que ve el gclid en la URL.
  // Medido: 0 de 3.996 sesiones de crédito atribuidas a Google.
  //
  // Acá solo se LEE. Si algún día este asset se carga en otra plantilla, sigue
  // funcionando sin cambios.

  function getCookie(name) {
    const m = document.cookie.match('(^| )' + name + '=([^;]+)');
    return m ? decodeURIComponent(m[2]) : null;
  }

  function getAttribution() {
    const p = new URLSearchParams(window.location.search);
    // Precedencia por fuente, de más fiable a menos:
    //   1. cookie de origen (90 días, escrita en la landing por el snippet)
    //   2. parámetro en la URL (si el usuario aterrizó directo acá)
    //   3. sessionStorage — SOLO por compatibilidad: cubre las sesiones que ya
    //      estaban abiertas el día del despliegue. Se puede quitar pasada una
    //      semana; sin esto, esas sesiones perderían la atribución al desplegar.
    return {
      fbp: getCookie('_fbp'),
      fbc: getCookie('_fbc') || getCookie('rc_fbc') || p.get('fbclid'),
      gclid: getCookie('rc_gclid') || p.get('gclid') || sessionStorage.getItem('rc_gclid'),
      gbraid: getCookie('rc_gbraid') || p.get('gbraid') || sessionStorage.getItem('rc_gbraid'),
      wbraid: getCookie('rc_wbraid') || p.get('wbraid') || sessionStorage.getItem('rc_wbraid')
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    const triggerBtn = document.getElementById('cart-refurbicredit-btn');
    const overlay    = document.getElementById('rc-modal-overlay');
    const closeBtn   = document.getElementById('rc-modal-close');
    const form       = document.getElementById('rc-customer-form');
    const errorEl    = document.getElementById('rc-form-error');
    const submitBtn  = form ? form.querySelector('[type="submit"]') : null;

    // Actualiza hero y totales con datos frescos del carrito
    function updateCartTotals(cart) {
      var fmt = window.money_format || '${{amount_with_comma_separator}}';
      var grandFormatted = Shopify.formatMoney(cart.total_price, fmt);
      var subFormatted   = Shopify.formatMoney(cart.original_total_price, fmt);

      var heroEl = document.querySelector('.rc-cart-hero__total');
      if (heroEl) heroEl.textContent = 'El total de tu carrito es de ' + grandFormatted;

      var grandEl = document.querySelector('.rc-totals__grand [data-cart-total-value]');
      if (grandEl) {
        grandEl.textContent = grandFormatted;
        grandEl.setAttribute('data-cart-total-value', cart.total_price);
      }

      var subEl = document.querySelector('.rc-totals__row span:last-child');
      if (subEl) subEl.textContent = subFormatted;
    }

    // Toast de deshacer: barra superior animada con opción de re-añadir el item eliminado
    function showUndoToast(name, onUndo, onDismiss) {
      var existing = document.querySelector('.rc-undo-toast');
      if (existing) existing.parentNode.removeChild(existing);

      var toast = document.createElement('div');
      toast.className = 'rc-undo-toast';
      toast.innerHTML =
        '<span>' + (name || 'El producto') + ' se ha eliminado de tu carrito</span>' +
        '<button class="rc-undo-toast__undo" type="button">Deshacer</button>' +
        '<button class="rc-undo-toast__close" type="button" aria-label="Cerrar">&#x2715;</button>';
      document.body.appendChild(toast);
      requestAnimationFrame(function () { toast.classList.add('rc-undo-toast--visible'); });

      var done = false;
      function dismiss() {
        if (done) return; done = true;
        toast.classList.remove('rc-undo-toast--visible');
        setTimeout(function () { toast.parentNode && toast.parentNode.removeChild(toast); }, 320);
      }

      var timer = setTimeout(function () { dismiss(); onDismiss && onDismiss(); }, 6000);
      toast.querySelector('.rc-undo-toast__undo').addEventListener('click', function () {
        clearTimeout(timer); dismiss(); onUndo();
      });
      toast.querySelector('.rc-undo-toast__close').addEventListener('click', function () {
        clearTimeout(timer); dismiss(); onDismiss && onDismiss();
      });
    }

    // Fuente de verdad: la respuesta de /cart/change.js (estado YA confirmado por el servidor).
    // Tanto "Eliminar" como el stepper −/+ de Halo pasan por aquí vía Shopify.removeItem/changeItem.
    (function interceptCartChange() {
      var origFetch = window.fetch;

      // Captura de click en fase de captura: antes de que Halo procese el evento
      // Guardamos el elemento DOM y los datos necesarios para el undo.
      // data-index="{{ item.index | plus: 1 }}" es lo que getCartUpdate envía como body.line
      var pending = null;

      document.addEventListener('click', function (e) {
        // Caso: botón "Eliminar"
        var removeBtn = e.target.closest('[data-cart-remove]');
        // Caso: botón "−" del stepper
        var minusBtn  = !removeBtn && e.target.closest('[data-minus-quantity-cart]');
        if (!removeBtn && !minusBtn) return;

        var li = e.target.closest('.cart-item');
        if (!li || li.classList.contains('is-refurbicare')) return;

        // Para el botón "−": solo capturar si la cantidad actual es 1 (va a llegar a 0)
        if (minusBtn) {
          var qtyInput = li.querySelector('[data-cart-quantity]');
          if (!qtyInput || parseInt(qtyInput.value) > 1) return;
          removeBtn = li.querySelector('[data-cart-remove]');
          if (!removeBtn) return;
        }

        var nameEl = li.querySelector('.cart-item-name .text');
        pending = {
          element:   li,
          name:      nameEl ? nameEl.textContent.trim() : null,
          variantId: removeBtn.dataset.cartRemoveId,
          quantity:  (function () {
            var q = li.querySelector('[data-cart-quantity]');
            return q ? (parseInt(q.value) || 1) : 1;
          })(),
          // Halo envía { id: item.key } en /cart/change.js — item.key === data-line
          lineKey: removeBtn.dataset.line
        };
      }, true); // fase de captura = antes de que Halo detenga la propagación

      window.fetch = function (input, init) {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var promise = origFetch.apply(this, arguments);
        if (!/\/cart\/change(\.js)?(\?|$)/.test(url)) return promise;

        // Determinar si esta llamada corresponde a la eliminación pendiente capturada.
        // Halo envía { id: item.key, quantity: 0 } — el id coincide con data-line del item.
        var toUndo = null;
        try {
          var reqBody = init && init.body ? JSON.parse(init.body) : {};
          var changeKey = reqBody.id || reqBody.line; // soporta ambas variantes
          if (reqBody.quantity === 0 && changeKey && pending) {
            if (!pending.lineKey || String(pending.lineKey) === String(changeKey)) {
              toUndo = pending;
            }
            pending = null;
          }
        } catch (e) {}

        // Ocultar el elemento inmediatamente al confirmar el servidor (sin esperar el re-render de Halo)
        return promise.then(function (response) {
          response.clone().json().then(function (cart) {
            if (!cart || typeof cart.item_count !== 'number') return;

            function doReload() { window.location.reload(); }
            function addBack() {
              if (!toUndo || !toUndo.variantId) { doReload(); return; }
              origFetch('/cart/add.js', {
                method: 'POST',
                // X-Refurbi-Undo marca esta llamada como restauración de un item que el
                // usuario acababa de eliminar, no como una adición nueva. El contador de
                // ATC (snippets/refurbi-atc-tracking.liquid) la excluye por esa cabecera:
                // origFetch aquí es su wrapper, no el fetch nativo, así que sin la marca
                // cada "Deshacer" se contaría como un add_to_cart.
                headers: { 'Content-Type': 'application/json', 'X-RefurbiCare': '1', 'X-Refurbi-Undo': '1' },
                body: JSON.stringify({ id: parseInt(toUndo.variantId), quantity: toUndo.quantity })
              }).then(doReload).catch(doReload);
            }

            // Ocultar el item eliminado + su slot RefurbiCare (ambos comparten data-line = item.key).
            // Inyectamos una regla CSS con !important en vez de tocar .style: el repaint de
            // RefurbiCare (global.js, ~500ms tras /cart/change) recrea el slot y revertiría display:none.
            // La regla persiste aunque el slot se recree, mientras conserve su data-line.
            if (toUndo && toUndo.lineKey) {
              var key = toUndo.lineKey;
              // animación de salida suave antes de que la regla colapse el espacio
              document.querySelectorAll('.cart-item, .rc-cart-slot').forEach(function (node) {
                if (node.getAttribute('data-line') === key) {
                  node.style.transition = 'opacity 0.15s';
                  node.style.opacity = '0';
                }
              });
              var sheet = document.getElementById('rc-hidden-lines');
              if (!sheet) {
                sheet = document.createElement('style');
                sheet.id = 'rc-hidden-lines';
                document.head.appendChild(sheet);
              }
              setTimeout(function () {
                sheet.textContent +=
                  '.cart-item[data-line="' + key + '"],.rc-cart-slot[data-line="' + key + '"]{display:none!important}';
                // El primer item que quede visible pierde su divisor superior
                // (:first-child del CSS sigue apuntando al item oculto, que aún está en el DOM).
                var items = document.querySelectorAll('.cart-list > .cart-item');
                for (var i = 0; i < items.length; i++) {
                  var dl = items[i].getAttribute('data-line');
                  if (items[i].classList.contains('is-refurbicare') || dl === key) continue;
                  sheet.textContent += '.cart-list>.cart-item[data-line="' + dl + '"]{border-top:none!important}';
                  break;
                }
              }, 160);
            }

            if (cart.item_count === 0) {
              showUndoToast(toUndo && toUndo.name, addBack, doReload);
            } else {
              updateCartTotals(cart);
              if (toUndo) showUndoToast(toUndo.name, addBack, null);
            }
          }).catch(function () {});
          return response;
        });
      };
    })();

    // Modal informativo "¿Qué es RefurbiCredit?"
    (function initInfoModal() {
      var infoOverlay = document.getElementById('rc-info-modal-overlay');
      if (!infoOverlay) return;

      function openInfo() { infoOverlay.style.display = 'flex'; }
      function closeInfo() { infoOverlay.style.display = 'none'; }

      ['rc-info-btn-hero', 'rc-info-btn-footer'].forEach(function (id) {
        var btn = document.getElementById(id);
        if (btn) btn.addEventListener('click', openInfo);
      });

      document.getElementById('rc-info-modal-close').addEventListener('click', closeInfo);
      infoOverlay.addEventListener('click', function (e) {
        if (e.target === infoOverlay) closeInfo();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && infoOverlay.style.display === 'flex') closeInfo();
      });
    })();

    // Campo de descuento estilo Apple en totales
    (function initHeroDiscount() {
      var toggle    = document.getElementById('rc-discount-toggle');
      var expand    = document.getElementById('rc-discount-expand');
      var hint      = document.getElementById('rc-discount-ingresar-hint');
      var input     = document.getElementById('rc-discount-code-hero');
      var applyBtn  = document.getElementById('rc-discount-apply-hero');
      var cancelBtn = document.getElementById('rc-discount-cancel');
      var feedback  = document.getElementById('rc-discount-feedback-hero');

      // Nota: no se ofrece "Quitar" en el carrito. Shopify no permite remover un código
      // de descuento del carrito por JS (la cookie es httpOnly / se guarda en el servidor);
      // el cliente puede removerlo de forma nativa en el checkout.

      if (!toggle || !expand) return;

      function openExpand() {
        expand.style.display = 'block';
        if (hint) hint.style.display = 'none';
        toggle.classList.add('rc-discount-toggle--open');
        if (input) setTimeout(function() { input.focus(); }, 30);
      }
      function closeExpand() {
        expand.style.display = 'none';
        if (hint) hint.style.display = '';
        toggle.classList.remove('rc-discount-toggle--open');
        if (feedback) { feedback.textContent = ''; feedback.className = 'rc-hero-discount__feedback'; }
      }

      toggle.addEventListener('click', function() {
        expand.style.display === 'none' ? openExpand() : closeExpand();
      });

      if (cancelBtn) cancelBtn.addEventListener('click', closeExpand);

      function setFeedback(msg, kind) {
        if (!feedback) return;
        feedback.textContent = msg || '';
        feedback.className = 'rc-hero-discount__feedback' + (kind ? ' rc-hero-discount__feedback--' + kind : '');
      }

      // Refleja un descuento aplicado en el DOM sin recargar la página (soft update)
      function showAppliedDiscount(cart) {
        updateCartTotals(cart); // subtotal + total + hero

        var savings = document.querySelector('.cart-discount.cart-total-savings');
        if (savings) {
          savings.style.display = 'flex';
          savings.setAttribute('data-dis', cart.total_discount);
          var valEl = savings.querySelector('[data-saved-discount-value]');
          if (valEl) {
            var fmt = window.money_format || '${{amount_with_comma_separator}}';
            valEl.textContent = '-' + Shopify.formatMoney(cart.total_discount, fmt);
          }
        }

        // Ocultar el toggle "¿Tienes un código?" y colapsar el campo
        var entry = document.getElementById('rc-discount-entry');
        if (entry) entry.style.display = 'none';
        expand.style.display = 'none';
        if (hint) hint.style.display = '';
        toggle.classList.remove('rc-discount-toggle--open');
      }

      if (applyBtn) {
        applyBtn.addEventListener('click', function() {
          var code = input ? input.value.trim() : '';
          if (!code) return;
          applyBtn.disabled = true;
          applyBtn.textContent = 'Aplicando…';
          setFeedback('', '');

          // 1) fetch a /discount/CODE fija la cookie discount_code (mismo mecanismo que
          //    coupon-code de halo-toolcart.js). 2) fetch a /cart.js nos devuelve el carrito
          //    ya con el descuento para (a) validar el código y (b) actualizar el DOM sin recargar.
          fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
            .then(function() { return fetch('/cart.js', { credentials: 'same-origin' }); })
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var lc = code.toLowerCase();
              var codes = cart.discount_codes || [];
              var match = codes.find(function(d) { return d.code && d.code.toLowerCase() === lc; });
              // Válido = se generó un descuento real, o el código figura como aplicable
              var applied = (cart.total_discount > 0) || (match && match.applicable !== false);

              if (applied && cart.total_discount > 0) {
                try { localStorage.setItem('storedDiscount', code); } catch (e) {}
                showAppliedDiscount(cart);
              } else {
                // Código inválido / no aplicable: limpiar rastro y avisar
                try { localStorage.removeItem('storedDiscount'); } catch (e) {}
                setFeedback('El código “' + code + '” no es válido o no aplica a tu carrito.', 'error');
                applyBtn.disabled = false;
                applyBtn.textContent = 'Aplicar';
                if (input) input.focus();
              }
            })
            .catch(function() {
              // Fallback ante error de red: recargar para mostrar el estado real
              try { localStorage.setItem('storedDiscount', code); } catch (e) {}
              window.location.href = '/cart';
            });
        });
      }

      if (input) {
        input.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') { if (applyBtn) applyBtn.click(); }
          if (e.key === 'Escape') { closeExpand(); }
        });
      }
    })();

    // RefurbiCare añade un plan vía /cart/add.js (no pasa por change) → escucha su evento propio
    document.addEventListener('refurbicare:cart-updated', function (e) {
      if (e.detail && e.detail.cart) updateCartTotals(e.detail.cart);
    });

    // A partir de aquí, lógica del modal: requiere que existan botón/overlay/form
    if (!triggerBtn || !overlay || !form) return;

    // Tracking tope de embudo: "iniciado" al abrir el modal (una vez por carga de página).
    var rcTracked = false;
    function trackIniciado() {
      if (rcTracked) return; rcTracked = true;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          fetch(BACKEND_URL + '/track', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            keepalive: true,
            body: JSON.stringify({
              eventType: 'iniciado',
              attribution: getAttribution(),
              cartTotal: String(cart.total_price || ''),
              itemCount: cart.item_count || 0
            })
          }).catch(function () {});
        })
        .catch(function () {
          fetch(BACKEND_URL + '/track', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            keepalive: true,
            body: JSON.stringify({ eventType: 'iniciado', attribution: getAttribution() })
          }).catch(function () {});
        });
    }

    // Abrir modal
    triggerBtn.addEventListener('click', function () {
      trackIniciado();
      overlay.style.display = 'flex';
      overlay.querySelector('input')?.focus();
    });

    // Cerrar modal
    closeBtn?.addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    function closeModal() {
      overlay.style.display = 'none';
      if (errorEl) errorEl.style.display = 'none';
    }

    // Envío del formulario
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (errorEl) errorEl.style.display = 'none';

      submitBtn.disabled = true;
      submitBtn.textContent = 'Procesando…';

      try {
        // 1. Obtener carrito actual
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();

        if (!cart.item_count) {
          throw new Error('El carrito está vacío.');
        }

        const lineItems = cart.items.map(item => ({
          variantId:    item.variant_id,
          productId:    item.product_id,
          title:        item.product_title || item.title,
          quantity:     item.quantity,
          price:        String(item.price),
          sku:          item.sku || '',
          // Orden 23 · T2. Sustitución por el helper canónico, que es una EXTRACCIÓN
          // literal de esta misma expresión — no una mejora. Si se comportara distinto
          // cambiarían los lineItems que se mandan a Creditop y los del draft order.
          // El respaldo inline se conserva por si el snippet no se renderizó: acá un
          // fallo silencioso cambiaría lo que se le cobra a un cliente.
          isRefurbicare: window.RefurbiLineItem
            ? window.RefurbiLineItem.isRefurbiCareLine(item)
            : !!(item.properties && (
                item.properties.__rc_type ||
                item.properties.__rc_parent_product_id
              ))
        }));

        const discountCodes = (cart.discount_codes || []).map(d => ({ code: d.code, amount: String(d.amount), type: d.type }));
        const totalDiscount = String(cart.total_discount || 0);

        // 2. Datos del cliente desde el formulario
        const fd = new FormData(form);
        const customer = {
          firstName:      fd.get('firstName')?.trim(),
          lastName:       fd.get('lastName')?.trim(),
          email:          fd.get('email')?.trim(),
          phone:          fd.get('phone')?.trim(),
          documentNumber: fd.get('documentNumber')?.trim(),
          address1:       fd.get('address1')?.trim(),
          city:           fd.get('city')?.trim(),
          province:       fd.get('province')?.trim(),
          zip:            fd.get('zip')?.trim() || ''
        };

        // 3. Atribución
        const attribution = getAttribution();

        // 4. Llamar al backend
        const res = await fetch(BACKEND_URL + '/credit-request', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            lineItems,
            customer,
            total: String(cart.total_price),
            attribution,
            discountCodes,
            totalDiscount
          })
        });

        if (!res.ok) {
          const body = await res.json().catch(() => ({}));
          throw new Error(body.message || 'Error del servidor (' + res.status + ')');
        }

        const { url } = await res.json();
        window.location.href = url;

      } catch (err) {
        console.error('[RefurbiCredit]', err);
        if (errorEl) {
          errorEl.textContent = err.message || 'Ocurrió un error. Intenta de nuevo.';
          errorEl.style.display = 'block';
        }
        submitBtn.disabled = false;
        submitBtn.textContent = 'Continuar a RefurbiCredit';
      }
    });
  });
})();
